module.exports = __webpack_public_path__ + "img/POL-F.082e66b1.png";